<style>
.el-tree-node__label {
  font-size: 12px;
}
</style>
<template>
  <div class="check-work-body d-flex">
    <div class="d-flex-left">
      <div class="tree-wrap">
        <div class="project-selector">
          <el-select size="mini" style="width: 100%" v-model="jurisdictionId" filterable placeholder="选择架构"
                     class="kuan" @change="checkedGetList">
            <el-option v-for="item in jurisdictionList" :key="item.id" :label="item.department_name"
                       :value="item.id">
            </el-option>
          </el-select>
          <el-button size="mini" @click="refreshTree" type="success">重置</el-button>
        </div>
        <div class="el-tree-1">
          <el-tree ref="tree" :data="data" :empty-text="emptyText" :props="defaultProps" :lazy="true"
                   :load="getData" @node-click="handleNodeClick"></el-tree>
        </div>
      </div>
    </div>
    <div class="d-flex-right">
      <div>
        <div class="search-wrap">
          <el-button size="mini" @click="getPreUserList" type="primary">查询</el-button>
          <el-button size="mini" @click="importExcelBasicSalary()" type="warning">导入基本工资</el-button>
          <el-button size="mini" @click="importExcel()" type="warning">导入</el-button>
          <el-button size="mini" @click="excelExportByUser()" type="warning">导出</el-button>
          <el-button size="mini" @click="checkImportExcel()" type="success">execl检查</el-button>
        </div>
        <!-- 搜索框 -->
        <div style="margin-bottom: 10px;">
          <el-descriptions :column="2" border size="mini">
            <el-descriptions-item label="所选架构" >
              <el-input size="mini" placeholder="" v-model="where.department" disabled></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="姓名">
              <el-input size="mini" placeholder="请输入姓名" v-model="where.name" clearable></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="手机号码">
              <el-input size="mini" placeholder="请输入手机号码" v-model="where.phone_number" clearable></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="身份证号码">
              <el-input size="mini" placeholder="请输入身份证号码" v-model="where.identity_card" clearable></el-input>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <!-- 表格 -->
        <div class="table-wrap">
          <el-table v-if="pageData" v-loading="loading" :data="pageData.list">
            <el-table-column prop="name" label="姓名" align="center" width="111"></el-table-column>
            <el-table-column prop="identity_card" label="身份证号码" align="center" width=""></el-table-column>
            <el-table-column prop="phone_number" label="手机号码" align="center" width=""></el-table-column>
            <el-table-column prop="job" label="职位" align="center" width=""></el-table-column>
            <el-table-column prop="on_job_status" label="在职状态" align="center" width="">
              <template slot-scope="scope">
                <span v-if="scope.row.on_job_status == 0">离职</span>
                <span v-if="scope.row.on_job_status == 1">正常</span>
                <span v-if="scope.row.on_job_status == 2">试用期</span>
              </template>
            </el-table-column>
            <el-table-column prop="hiredate" label="入职时间" align="center" width=""></el-table-column>
            <el-table-column prop="organization" label="机构" align="center" width=""></el-table-column>
            <el-table-column prop="employee_to" label="员工归属" align="center" width=""></el-table-column>
            <el-table-column prop="gender" label="性别" align="center" width="">
              <template slot-scope="scope">
                <span v-if="scope.row.gender == 1">男</span>
                <span v-if="scope.row.gender == 2">女</span>
              </template>
            </el-table-column>
            <el-table-column prop="sum_salary" label="工资总数" align="center" width=""></el-table-column>
            <el-table-column prop="bank_name" label="发卡银行" align="center" width=""></el-table-column>
            <el-table-column prop="bank_number" label="银行卡号" align="center" width=""></el-table-column>
            <el-table-column prop="address" label="地址" align="center" width=""></el-table-column>
            <el-table-column prop="operation" label="操作" width="">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="edit(scope.row)">修改</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total=pageData.total
                         :page-size="pageData.pageSize * 1" :current-page="pageData.page * 1"
                         @current-change="pageChange"></el-pagination>
        </div>
      </div>
    </div>
    <!-- 修改窗口 -->
    <el-dialog title="编辑" z-index="990" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px">
      <div style="max-height: 700px;overflow-y: auto;">
        <el-input size="mini" type="hidden" v-model="update_form.project_id"></el-input>
        <el-descriptions class="margin-top" title="" :column="2" size="mini" border>
          <el-descriptions-item label="姓名">
            <el-input size="mini" class="form-input" v-model="update_form.name" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="职位">
            <el-select size="mini" style="width: 100%" v-model="update_form.job_id" filterable
                       placeholder="职位" class="kuan">
              <el-option v-for="item in job_list" :key="item.id" :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="身份证号码">
            <el-input size="mini" class="form-input" v-model="update_form.identity_card"
                      autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="手机号码">
            <el-input size="mini" class="form-input" v-model="update_form.phone_number"
                      autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="机构">
            <el-input size="mini" class="form-input" v-model="update_form.organization"
                      autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="项目">
            <el-input size="mini" class="form-input" v-model="update_form.project"
                      autocomplete="off" readonly @focus="editProject"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="员工归属">
            <el-input size="mini" class="form-input" v-model="update_form.employee_to"
                      autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="性别">
            <el-select size="mini" style="width: 100%" v-model="update_form.gender" filterable
                       placeholder="性别" class="kuan">
              <el-option v-for="item in sex_list" :key="item.id" :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="年龄">
            <el-input size="mini" class="form-input" v-model="update_form.age" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="在职状态">
            <el-select size="mini" style="width: 100%" v-model="update_form.on_job_status" filterable
                       placeholder="在职状态" class="kuan">
              <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="银行名称">
            <el-input size="mini" class="form-input" v-model="update_form.bank_name" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="银行开户所在省份">
            <el-input size="mini" class="form-input" v-model="update_form.bank_province" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="银行开户所在城市">
            <el-input size="mini" class="form-input" v-model="update_form.bank_city" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="银行卡号">
            <el-input size="mini" class="form-input" v-model="update_form.bank_number"
                      autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="紧急联系人">
            <el-input size="mini" class="form-input" v-model="update_form.exigency_user_name"
                      autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="紧急联系人电话">
            <el-input size="mini" class="form-input" v-model="update_form.exigency_user_phone"
                      autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="入职时间">
            <el-date-picker v-model="update_form.hiredate" type="date" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" placeholder="选择日期">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="正常工作工资">
            <el-input size="mini" class="form-input" v-model="update_form.normal_salary"
                      :disabled="true"
                      autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="固定加班工资">
            <el-input size="mini" class="form-input" v-model="update_form.fixed_overtime_salary"
                      :disabled="true"
                      autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="综合工资总额">
            <el-input size="mini" class="form-input" v-model="update_form.comprehensive_sum_salary"
                      :disabled="true"
                      autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="岗位补贴">
            <el-input size="mini" class="form-input" @change="editSalary()" v-model="update_form.job_subsidies"
                      autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="绩效工资">
            <el-input size="mini" class="form-input" @change="editSalary()" v-model="update_form.perf_salary"
                      autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="工资总额">
            <el-input size="mini" class="form-input" @change="editSalary()" v-model="update_form.sum_salary"
                      autocomplete="off"></el-input>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">关 闭</el-button>
        <el-button size="mini" @click="save_form()">确认</el-button>
      </div>
    </el-dialog>
    <select-department ref="selectDepartment" />
  </div>
</template>
<script>
import Http from "./common/Http";
import CommonHelp from "./common/CommonHelp";
import selectDepartment from "../Personnel/components/selectDepartment";
import { Admin, User, UserManage, DateFormat } from './common.js'

export default {
  components:{selectDepartment},
  name: "preUserManage",
  data() {
    return {
      jurisdictionId: '',
      jurisdictionList: [],
      data: [],
      emptyText: '没有数据',
      defaultProps: {
        children: '',
        label: 'department_name'
      },
      keyword: '',
      loading: false,
      where: {
        //搜索框
        name: "",
        department: "",
        phone_number:"",
        identity_card:"",
      },
      pageData: {
        list: [],
        total: 0,
        page_size: 10,
        page: 1
      },
      dialogVisible: false,
      update_form: {
      },

      meter_type_list: [{
        id: 0,
        name: '离职'
      }, {
        id: 1,
        name: '正常'
      }, {
        id: 2,
        name: '试用期'
      },],
      sex_list: [{
        id: '1',
        name: '男'
      }, {
        id: '2',
        name: '女'
      }],
      //职位列表
      job_list: [],
      nodeLevel: '',
      department_id: ""
    }
  },
  // 获取列表
  mounted() {
    this.myGetList();
    this.getPreUserList();
  },
  methods: {
    // 导入excel
    importExcel() {
      var that = this;
      let upload = document.getElementById("uploadFile-9999");
      if (!upload) {
        upload = document.createElement('input');
        upload.type = "file";
        upload.id = "uploadFile-9999";
        upload.style.display = "none";
      }
      upload.click();
      upload.onchange = function (e) {

        let formData = new FormData();
        formData.append("user_file", this.files[0]);
        Http.post(Http.getPreBaseURL() + '/oa/PreUserInfo/importUser', formData, res => {
          that.$message({type: res.code == 0 ? 'success' : 'error', message: res.msg})
        })
        upload.onchange = undefined;
      }
    },
    // 导入基本工资
    importExcelBasicSalary() {
      var that = this;
      let upload = document.getElementById("uploadFile-9999");
      if (!upload) {
        upload = document.createElement('input');
        upload.type = "file";
        upload.id = "uploadFile-9999";
        upload.style.display = "none";
      }
      upload.click();
      upload.onchange = function (e) {
        let formData = new FormData();
        formData.append("user_file", this.files[0]);
        Http.post(Http.getPreBaseURL() + '/oa/PreUserInfo/importExcelBasicSalary', formData, res => {
          that.$message({type: res.code == 0 ? 'success' : 'error', message: res.msg})
        })
        upload.onchange = undefined;
      }
    },
    // 部门列表
    myGetList(params) {
      Http.get(Http.getFlowBaseURL() + '/hr/department/getHuaRuiDepartmentList', params, res => {
        if (res.code === 0) {
          this.data = res.data;
          this.jurisdictionList = res.data;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
      })
    },
    // pre人员列表
    getPreUserList() {
      let params = this.where
      params['level'] = this.nodeLevel
      params['department_id'] = this.department_id
      params['page'] = this.pageData.page
      params['page_size'] = this.pageData.page_size
      Http.get(Http.getPreBaseURL() + "/oa/PreUserInfo/getUserInfoList", params, res => {
        if (res.code === 0) {
          this.pageData.list = res.data.data;
          this.pageData.total = res.data.total;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },
    // pre职业列表
    getPreJobList(params, url) {
      Http.get(Http.getPreBaseURL() + "/oa/PreUserJob/getJobList", params, res => {

        if (res.code === 0) {
          this.job_list = res.data;
          // this.pageData.total = res.data.total;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });

        }
      })
    },
    // 单选部门list
    checkedGetList(params) {
      Http.get(Http.getFlowBaseURL() + "/hr/department/getHuaRuiDepartmentList", {
        parent_id: params,
      }, res => {

        if (res.code === 0) {
          this.data = res.data;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });

        }
      })
    },
    // 分页--选中页码
    pageChange(i) {
      this.pageData.page = i;
      this.pageData.page_size = 10;
      this.getPreUserList();
    },
    // 点击树形节点+搜索  = 输出表格
    handleNodeClick(data) {
      this.department_id = data.id
      this.nodeLevel = data.level
      this.where.department = data.ancestor_name
      this.pageData.page = 1

      this.getPreUserList();
    },
    // 刷新右边树
    refreshTree() {
      this.department_id = 0
      this.nodeLevel = 0
      this.where.department = ""
      this.pageData.page = 1
      this.myGetList();
      this.jurisdictionId = [];
      this.getPreUserList()

    },
    // 点击编辑按钮
    edit(item) {
      this.getUserInfo(item.id);
      this.getPreJobList();
      this.dialogVisible = true;
    },
    // 点击修改表单提交
    save_form() {
      if (!this.update_form.name) {
        return this.$message({
          message: '请填写姓名',
          type: 'error'
        });
      }
      if (!this.update_form.organization) {
        return this.$message({
          message: '请填写机构',
          type: 'error'
        });
      }
      if (!this.update_form.job_id) {
        return this.$message({
          message: '请填写职位',
          type: 'error'
        });
      }
      if (!this.update_form.identity_card) {
        return this.$message({
          message: '请填写身份证号码',
          type: 'error'
        });
      }
      if (!this.update_form.project) {
        return this.$message({
          message: '请填写项目',
          type: 'error'
        });
      }
      if (!this.update_form.normal_salary) {
        return this.$message({
          message: '请填写正常工作时间工资',
          type: 'error'
        });
      }
      if (!this.update_form.bank_name) {
        return this.$message({
          message: '请填写银行名称',
          type: 'error'
        });
      }
      if (!this.update_form.bank_province) {
        return this.$message({
          message: '请填写银行卡开户省份',
          type: 'error'
        });
      }
      if (!this.update_form.bank_city) {
        return this.$message({
          message: '请填写银行卡开户城市',
          type: 'error'
        });
      }
      if (!this.update_form.bank_number) {
        return this.$message({
          message: '请填写银行卡号',
          type: 'error'
        });
      }
      if (!this.update_form.phone_number) {
        return this.$message({
          message: '请填手机号',
          type: 'error'
        });
      }
      if (!this.update_form.gender) {
        return this.$message({
          message: '请选择性别',
          type: 'error'
        });
      }
      if (!this.update_form.age) {
        return this.$message({
          message: '请选择年龄',
          type: 'error'
        });
      }
      if (!this.update_form.hiredate) {
        return this.$message({
          message: '请填写在入职时间',
          type: 'error'
        });
      }

      let that = this;
      Http.post(Http.getPreBaseURL() + "/oa/PreUserInfo/save", this.update_form,
        res => {
          if (res.code === 0) {
            this.dialogVisible = false;
            this.$message({
              message: res.msg,
              type: 'success'
            });
            that.getPreUserList();
          } else {
            this.$message.error({
              message: res.msg,
              type: "error",
            });
          }
        })
    },
    // 获取个人信息
    getUserInfo(params) {
      Http.get(Http.getPreBaseURL() + "/oa/PreUserInfo/getUserInfoById", {
        id: params,
      }, res => {
        if (res.code === 0) {
          this.update_form = res.data;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },
    // 节点下面的数据
    getData(node, resolve) {
      var region_id = node.data.id;//选中节点id
      var _this = this;
      setTimeout(() => {
        //节点不能为空
        if (region_id == '' || region_id == undefined) {
          return false;
        }
        //加载
        node.data.region_id = region_id;
        node.data && Http.get(Http.getFlowBaseURL() + '/hr/department/getHuaRuiDepartmentList', {parent_id: node.data.id,}, backdata => { // 异步执行成功后
          return resolve(backdata.data);
        });
      }, 300);
    },
    // 导出按钮
    excelExportByUser() {
      var keyword = ''
      var level = ''
      if (this.where.name) {
        keyword = this.where.name
      } else if (this.where.phone) {
        keyword = this.where.phone
      }
      var params = {
        level: this.nodeLevel,
        department_id: this.department_id,
        keyword: keyword,
      }
      Http.get(Http.getPreBaseURL() + "/oa/PreUserInfo/excelExportByUser", params, res => {
        if (res) {
          window.open(CommonHelp.getBaseURL() + res.data)
          this.$message({
            message: '导出成功',
            type: 'success'
          });
        } else {
          this.$message.error({
            message: '导出失败',
            type: "error",
          });
        }
      })
    },
    // 检查导入的excel
    checkImportExcel() {
      var that = this;
      let upload = document.getElementById("uploadFile-9999");
      if (!upload) {
        upload = document.createElement('input');
        upload.type = "file";
        upload.id = "uploadFile-9999";
        upload.style.display = "none";
      }
      upload.click();
      upload.onchange = function (e) {
        let formData = new FormData();
        formData.append("user_file", this.files[0]);
        Http.post(Http.getPreBaseURL() + '/oa/PreUserInfo/checkImportExcelUser', formData, res => {
          that.$message({type: res.code == 0 ? 'success' : 'error', message: res.msg})
        })
        upload.onchange = undefined;
      }
    },
    // 修改项目
    editProject() {
      let that = this;
      this.$refs.selectDepartment.show({}, data=>{
        that.update_form.project = data['department_name']
        that.update_form.project_id = data['id']
      })
    },
    // 修改薪资
    editSalary() {
      // 薪资总额 - 岗位补贴 - 绩效
      let sj = UserManage.Sub(this.update_form.sum_salary, this.update_form.job_subsidies)
      let sjp = UserManage.Sub(sj, this.update_form.perf_salary)
      this.update_form.fixed_overtime_salary = UserManage.Sub(sjp,this.update_form.normal_salary)
    }
  }
}

function reObject(item) {
  return JSON.parse(JSON.stringify(item));
}
</script>
<style lang="scss" scoped>
.el-button--primary,
.el-button--danger,
.el-button--success,
.el-button--warning {
  color: #fff;
}

.el-tree-node__label {
  font-size: 12px;
}

.check-work-body {
  padding: 15px;
  width: 98%;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
  display: flex;
}

.salary-time-picker {
  margin-left: 10px;
  margin-right: 10px;
  font-size: 20px;
}

.table-wrap {
  margin-top: 5px;
  //height: calc(70vh) !important;
  //overflow: auto !important;
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}


.check-work-tb {
  border-collapse: collapse;

  td,
  th {
    border: 1px solid #EBEEF5;
    line-height: 20px;
    padding: 10px 10px;
    font-size: 12px;
  }

  th {
    font-weight: bold;
    text-align: left;
  }
}

.el-calendar-table .el-calendar-day {
  height: 50px;
}

.check-work-class-editor {
  margin-top: 10px;
  width: 100%;

  .cw-header {
    width: 100%;
    display: table;
    border-collapse: collapse;

    .cw-title {
      display: table-cell;
      border: 1px solid #EBEEF5;
      padding: 5px 10px;
      line-height: 20px;
      font-weight: bold;

      &.cw-name {
        width: 100px;
      }

      &.cw-class {
        flex: 1;
      }
    }

  }

}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  //flex: 1;
}

.form-input {
  width: 100%;
}

.table-wrap {
  width: calc(100vw - 450px);
  overflow-x: scroll;
  //width: 100%;

}

.amap-box {
  width: 500px;
  height: 500px;
}

.el-tree-1 {

  overflow-y: scroll;
  height: calc(100vh - 120px);
  width: 100%;
}


.fangtai-name {
  font-size: 12px;
}

.tree-wrap {
  width: 250px;
}

.project-selector {
  margin-bottom: 10px;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Oa/PreUserManage.vue